export default __webpack_public_path__ + "static/media/(32)-min.9c346852.jpg";